import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { KeyValuePipe, NgForOf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SidenavContentRef } from '../../shared/sidenav/sidenav-content/sidenav-content-ref';
import { SIDENAV_CONTENT_DATA } from '../../shared/sidenav/sidenav-content/sidenav-content.service';
import { ButtonSpacerDirective } from '../../shared/directives/button.directive';
import { originalOrderFunction } from '../../../../functions/original-order';
import { MatRadioModule } from '@angular/material/radio';
import { CapitalizePipeModule } from '../../../../pipes/format/capitalize.module';
import { TableFilters } from '../../../../models/entities/table-filters';
import { SidenavContentModule } from '../../shared/sidenav/sidenav-content/sidenav-content.module';

export interface ViolationFiltersSidenavInput {
    filters: TableFilters;
}

export interface ViolationFiltersSidenavOutput {
    success: true;
    filters: TableFilters;
}

export enum ViolationStates {
    PENDING = 'pending',
    COMPLETED = 'completed',
    ALL = 'all',
}

export enum ViolationPastDue {
    GT30 = 'past due > 30',
    LT30 = 'past due < 30',
    ALL = 'all',
}

@Component({
    selector: 'app-violation-filters-sidenav',
    templateUrl: './violation-filters-sidenav.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        KeyValuePipe,
        MatButtonModule,
        ButtonSpacerDirective,
        NgForOf,
        MatRadioModule,
        CapitalizePipeModule,
        SidenavContentModule,
    ],
})
export class ViolationFiltersSidenavComponent
{
    formGroup = this._fb.nonNullable.group({
        state: this.data.filters.state || 'pending',
        pastDue: this.data.filters.pastDue  || 'all',
    });

    readonly violationStates = ViolationStates;
    readonly violationPastDue = ViolationPastDue;
    readonly originalOrder = originalOrderFunction;

    constructor(
            private _fb: FormBuilder,
            private _sidenavRef: SidenavContentRef<ViolationFiltersSidenavComponent>,
            @Inject(SIDENAV_CONTENT_DATA) public data: ViolationFiltersSidenavInput,
    ) {
    }

    getValue(key: ViolationPastDue) {
        switch (key) {
            case ViolationPastDue.LT30:
                return 'pastDueUnderThirty';
            case ViolationPastDue.GT30:
                return 'pastDueOverThirty';
            default:
                return 'all';
        }
    }

    applyFilters() {
        const output: ViolationFiltersSidenavOutput = {
            success: true,
            filters: this.formGroup.value,
        };
        this._sidenavRef.close(output);
    }
}
